import { AbstractPmsApiService } from './abstract.service';
import { ReservationDocument } from '../models';

/**
 * @class ReservationDocumentPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ReservationDocument>}
 */
export class ReservationDocumentPmsApiService extends AbstractPmsApiService {

    static get $inject() {

        return super.$inject.concat(['Upload']);
    }

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/reservation/:reservationId/document(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param params
     * @returns {ReservationDocument}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ReservationDocument(attributes);
    }

    constructor(http, config, eventsBroker, Upload) {

        super(http, config, eventsBroker);

        this.Upload = Upload;
    }

    /**
     * @param {Object=} params
     * @param {Reservation=} reservation
     * @returns {Promise.<PaginationCollection<ReservationDocument>>}
     */
    get(params = {}, reservation) {

        const url = this.url({
            reservationId: reservation.id
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    upload(document, reservation) {

        const url = this.url({
            reservationId: reservation.id
        });

        if (document instanceof File) {
            return this.Upload
                .upload({
                    url: url,
                    headers: this.authHeaders,
                    data: {document},
                })
                .then(this.getModeler())
                .catch(this.getErrorHandler());
        }
    }

    /**
     * @param {ReservationDocument} document
     * @returns {Promise.<boolean>}
     */
    delete(document) {

        const url = this.url({
            reservationId: document.reservation_id,
            id: document.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

}



// WEBPACK FOOTER //
// ./src/pms-api/services/reservation-documents.service.js